var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChampionM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 3H8H6V5L4.00012 5H2.00012V7V15H4.00012L6 15H8V7H8.00012V5L16.0002 5V7V15L18.0001 15L18.0002 15L20 15H22V7H22.0002V5H22H20H18.0002V3H18H16.0002ZM20 7V13H18.0002V7H20ZM6 13H4.00012V7H6V13ZM18 15.0001H6V17.0001H18V15.0001ZM11 17.0001H13V19H16.0002V21H13V21.0001H11V21H8.00024V19H11V17.0001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampionM);
export default __webpack_public_path__ + "static/media/champion-m.25f7ace37441fd3ecd8993c86b166e29.svg";
export { ForwardRef as ReactComponent };